import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import MarqueeStrip from "../components/landing/MarqueeStrip";
import Manifesto from "../components/landing/Manifesto";
import MenuSection from "../components/landing/MenuSection";
import Location from "../components/landing/Location";
import Footer from "../components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -72 }); }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <MenuSection />
        <Location />
      </main>
      <Footer />
    </>
  );
}
